// South Alabama (SAL_JAG) real accounts: TrackMan sync isn't finished for them yet (as of the
// 2026-10-01 intersquad upload, every report IS available — nothing here restricts access
// anymore). This only drives a heads-up notice on the Home page so coaches know why numbers
// might still be catching up; demo accounts and Admins don't need to see it.
export const TRACKMAN_SYNC_MESSAGE =
  'TrackMan data is still syncing for your program — all reports are available, but some numbers may be incomplete until the sync finishes soon.';

// 2026-10-27: South Alabama now reads its full TrackMan account (every team's games), so no
// account is gated any more -- the Home notice, the other-teams notices and the Portal / JUCO
// blur all key off this one gate and are off. Return the old test here to bring them back.
export function needsTrackmanSyncNotice() {
  return false;
}

// Shown on the cross-team scouting pages (Lineup Report, Opposing Pitching Report,
// Infield/Outfield Report, Pitcher Video, Dugout Scouting) — those pull another team's
// TrackMan data, which isn't available for opponents yet. Same SAL_JAG-non-demo audience as
// needsTrackmanSyncNotice above; reuse that same gate.
export const TRACKMAN_OTHER_TEAMS_MESSAGE =
  "TrackMan is not fully integrated, and access to other teams' data is not available at this time.";

// Portal and JUCO Leaderboard are fully blocked (blurred, not just noted) for the same
// SAL_JAG-non-demo audience — see components/BlurredUnavailable.js and its use in App.js/
// Navigation.js. Reuses needsTrackmanSyncNotice's gate rather than duplicating it.
export const RECRUITING_BLOCKED_MESSAGE = 'Not available at this time.';
